'use client';

import React, { useEffect, useState } from 'react';
import {
    getFontPreviewFamilies,
    injectGoogleFontPreviewStylesheets,
    isFontLoaded,
} from '../../fonts/fontPreview';
import { DEV_PANEL_TEST_IDS } from '../DevPanel.consts';
import {
    fontListStyle,
    fontNameStyle,
    fontRowStyle,
    fontSampleStyle,
    fontStatusStyle,
} from '../DevPanel.style';

const FONT_LOAD_RECHECK_DELAY_MILLISECONDS = 1500;
const FONT_PREVIEW_FAMILIES = getFontPreviewFamilies();
const LOADED_STATUS = '\u2705';
const MISSING_STATUS = '\u274C';

export const FontPreviewList = (): React.ReactElement => {
    const [loadedByFamily, setLoadedByFamily] = useState<Record<string, boolean>>({});

    useEffect(() => {
        injectGoogleFontPreviewStylesheets();
        let cancelled = false;

        const recompute = (): void => {
            const next = Object.fromEntries(
                FONT_PREVIEW_FAMILIES.map((family) => [family, isFontLoaded(family)]),
            );
            if (!cancelled) {
                setLoadedByFamily(next);
            }
        };

        recompute();
        if (document.fonts === undefined) {
            return () => {
                cancelled = true;
            };
        }
        document.fonts.ready.then(() => {
            if (cancelled) {
                return;
            }
            recompute();
            window.setTimeout(() => {
                if (!cancelled) {
                    recompute();
                }
            }, FONT_LOAD_RECHECK_DELAY_MILLISECONDS);
        });

        return () => {
            cancelled = true;
        };
    }, []);

    return (
        <div data-testid={DEV_PANEL_TEST_IDS.fontList} style={fontListStyle}>
            {FONT_PREVIEW_FAMILIES.map((family) => {
                let status = MISSING_STATUS;
                if (loadedByFamily[family] === true) {
                    status = LOADED_STATUS;
                }

                return (
                    <div key={family} style={fontRowStyle}>
                        <span style={fontStatusStyle}>{status}</span>
                        <span style={fontNameStyle}>{family}</span>
                        <span style={{ ...fontSampleStyle, fontFamily: `"${family}"` }}>
                            {`Aa Gg 123 — ${family}`}
                        </span>
                    </div>
                );
            })}
        </div>
    );
};
